<!-- faq-sidebar.component.html -->
<ng-container *ngIf="true">
  <div class="faq-sidebar-container">
    <div class="faq-header">
      <span class="faq-header-icon">
        <img src="assets/icon/slot.svg" width="28" height="28" alt="Ayuda" />
      </span>
      <span class="faq-header-title">Preguntas frecuentes</span>
      <ion-button class="close" fill="clear" shape="round" (click)="closeMenu()">
        <ion-icon src="assets/icon/cross.svg"></ion-icon>
      </ion-button>
    </div>
    <div class="faq-header-separator"></div>
    <div class="faq-content" #faqContent>
      <div class="faq-section-type">
        <div class="faq-section-title">Elige el tipo de consulta</div>
        <div class="faq-categories-list">
          <button *ngFor="let cat of categories" class="faq-category-item" (click)="scrollToSection(cat.id)">
            <img [src]="'assets/icon/' + cat.icon" [alt]="cat.label" class="faq-category-icon" />
            <span class="faq-category-desc">
              {{ cat.label }}
            </span>
          </button>
        </div>
      </div>

      <div *ngFor="let cat of categories; let last = last">
        <div [id]="cat.id" class="faq-section-block">
          <div class="faq-section-header-row">
            <img [src]="'assets/icon/' + cat.icon" [alt]="cat.label" class="faq-section-header-icon" />
            <span class="faq-section-header-title">{{ cat.label }}</span>
          </div>
          <div class="faq-question-list">
            <ng-container *ngFor="let faq of getFaqsByCategory(cat.key)">
              <div class="faq-question-item" (click)="toggleAccordion(faq.id)">
                <div class="faq-question-row">
                  <span class="faq-question-text">{{ faq.question }}</span>
                  <span class="faq-question-plus" [class.open]="accordionOpen[faq.id]">+</span>
                </div>
                <div class="faq-answer" *ngIf="accordionOpen[faq.id]" (click)="$event.stopPropagation()">
                  <div class="faq-content" [innerHTML]="faq.answer"></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="!last" class="faq-category-separator"></div>
      </div>
    </div>
  </div>
</ng-container>
